import { render, staticRenderFns } from "./ConfigBanner.vue?vue&type=template&id=20ef652c&scoped=true&"
import script from "./ConfigBanner.vue?vue&type=script&lang=js&"
export * from "./ConfigBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBanner.vue?vue&type=style&index=0&id=20ef652c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ef652c",
  null
  
)

export default component.exports